import { waLink, PRESET } from "@/lib/whatsapp";

export const HowItWorks = ({ t, lang }) => {
  return (
    <section
      id="how"
      className="relative py-14 md:py-20 bg-bendito-surface border-y border-bendito-border"
      data-testid="how-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="mb-12 max-w-2xl reveal">
          <div className="eyebrow mb-3">{t.how.eyebrow}</div>
          <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
            <span className="ink-underline">{t.how.title}</span>
          </h2>
          <p className="text-bendito-muted mt-3">{t.how.sub}</p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {t.how.steps.map((s, i) => (
            <li
              key={s.n}
              className="group glow-on-hover bg-bendito-bg border border-bendito-border p-7 hover:border-bendito-orange transition-colors duration-300 reveal"
              data-testid={`how-step-${i}`}
            >
              <div className="font-mono text-[11px] tracking-[0.3em] text-bendito-orange">
                STEP {s.n}
              </div>
              <h3 className="font-heading text-bendito-ink text-2xl mt-3 tracking-wider uppercase">
                {s.title}
              </h3>
              <p className="text-bendito-muted text-sm mt-3 leading-relaxed">{s.body}</p>
            </li>
          ))}
        </ol>

        <div
          className="mt-10 bg-bendito-bg border-l-4 border-bendito-orange p-6 md:p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-5"
          data-testid="how-highlight"
        >
          <p className="text-bendito-ink/95 md:text-lg leading-relaxed max-w-2xl">
            {t.how.highlight}
          </p>
          <a
            href={waLink(lang === "es" ? PRESET.generalEs : PRESET.generalEn)}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center justify-center bg-bendito-orange hover:bg-bendito-orangeDark text-black font-heading tracking-[0.22em] text-sm px-6 py-3 transition-colors"
            data-testid="how-cta"
          >
            {t.how.cta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
